import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resources-planning',
  templateUrl: './resources-planning.component.html',
  styleUrls: ['./resources-planning.component.scss']
})
export class ResourcesPlanningComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
